import { GLOBALS } from '../../js/globals';
import ScrollMagic from 'scrollmagic';

const smController = new ScrollMagic.Controller();

document.querySelectorAll('.js-city-video').forEach(video => {
    video.play();
});

if (!GLOBALS.mobile) {
    document.querySelectorAll('.js-activities-video').forEach(video => {
        video.setAttribute('preload', true);
    });

    document.querySelectorAll('.js-activities-item').forEach(el => {
        const video = el.querySelector('.js-activities-video');

        el.addEventListener('mouseenter', () => {
            video?.play();
        });

        el.addEventListener('mouseleave', () => {
            video?.pause();
        });
    });
}

// const animateCity = function() {
    // document.querySelector('.js-city')?.classList.add('_is-animated');
// }

// preloader.then(animateCity);



class Splash {
    constructor(el) {
        this.container = el;
        this.sceneMask = null;
        this.sceneOpacity = null;
        this.progressMask = 0;
        this.progressOpacity = 0;
        this.triggerMask = this.container.querySelector('.js-splash-trigger-m');
        this.triggerOpacity = this.container.querySelector('.js-splash-trigger-o');
        this.left = this.container.querySelector('.js-splash-left');
        this.right = this.container.querySelector('.js-splash-right');
        this.dark = this.container.querySelector('.js-splash-dark');

        this.handleScrollMask();
        this.handleScrollOpacity();
        this.handleUpdate();
    }

    handleScrollMask() {
        this.sceneMask = new ScrollMagic.Scene({
            triggerElement: this.triggerMask,
            triggerHook: 1,
            duration: this.getDuration(),
            reverse: true
        })
        .addTo(smController)
        .on('enter', () => {
            // console.log('enter');
        })
        .on('leave', () => {
            // console.log('leave');
        })
        .on('progress', (e) => {
            this.progressMask = e.progress;
            this.animateMask();
        });
    }

    handleScrollOpacity() {
        this.sceneOpacity = new ScrollMagic.Scene({
            triggerElement: this.triggerOpacity,
            triggerHook: 1,
            duration: this.getDuration(),
            reverse: true
        })
        .addTo(smController)
        .on('enter', () => {
            // console.log('enter o');
        })
        .on('leave', () => {
            // console.log('leave o');
        })
        .on('progress', (e) => {
            this.progressOpacity = e.progress;
            this.animateOpacity();
        });
    }


    handleUpdate() {
        window.addEventListener('resize', () => {
            this.updateScene();
        });
    }

    getDuration() {
        return window.innerHeight;
    }

    updateScene() {
        this.sceneMask.duration(this.getDuration());
        this.sceneOpacity.duration(this.getDuration());
        this.sceneMask.refresh();
        this.sceneOpacity.refresh();
    }

    animateMask() {
        this.offset = (1 - this.progressMask) * 100;
        this.radius = (1 - this.progressMask) * 50;

        this.left.style.clipPath = `inset(
            0% ${(1 - this.progressMask) * 100}% 0% 0%
            round 0 ${this.radius}rem ${this.radius}rem 0
        )`;

        this.right.style.clipPath = `inset(
            0% 0% 0% ${(1 - this.progressMask) * 100}%
            round ${this.radius}rem 0 0 ${this.radius}rem
        )`;
    }

    animateOpacity() {
        this.triggerMask.style.opacity = 1 - this.progressOpacity;
    }
}

document.querySelectorAll('.js-splash').forEach(el => {
    new Splash(el);
});


// Locations
const locationPoints = document.querySelectorAll('.js-location-point');
const locationBtns = document.querySelectorAll('.js-location-btn');

locationBtns.forEach(btn => {
    const type = btn.dataset.type;

    btn.addEventListener('mouseenter', () => {
        locationPoints.forEach(point => {
            if (point.dataset.type === type) {
                point.classList.add('_is-active');
            } else {
                point.classList.remove('_is-active');
            }
        });
    });

    btn.addEventListener('mouseleave', () => {
        locationPoints.forEach(point => {
            if (point.dataset.type === type) {
                point.classList.remove('_is-active');
            }
        });
    });
});

locationPoints.forEach(point => {
    const type = point.dataset.type;

    point.addEventListener('mouseenter', () => {
        point.classList.add('_is-active');

        locationBtns.forEach(btn => {
            if (btn.dataset.type === type) {
                btn.classList.add('_is-active');
            } else {
                btn.classList.remove('_is-active');
            }
        });
    });

    point.addEventListener('mouseleave', () => {
        point.classList.remove('_is-active');

        locationBtns.forEach(btn => {
            if (btn.dataset.type === type) {
                btn.classList.remove('_is-active');
            }
        });
    });
});

// Karaoke effect
class Karaoke {
    constructor(el) {
        this.container = el;
        this.scene = null;
        this.progress = 0;

        this.wrapChars();
        this.handleScroll();
        this.handleUpdate();
    }

    handleScroll() {
        this.scene = new ScrollMagic.Scene({
            triggerElement: this.container,
            triggerHook: 1,
            offset: 70,
            duration: this.getDuration(),
            reverse: true
        })
        .addTo(smController)
        .on('enter', () => {
            // console.log('enter');
        })
        .on('leave', () => {
            // console.log('leave');
        })
        .on('progress', (e) => {
            this.progress = e.progress;
            this.animate();
        });
    }


    handleUpdate() {
        window.addEventListener('resize', () => {
            this.updateScene();
        });
    }

    getDuration() {
        return window.innerHeight * 0.9;
    }

    updateScene() {
        this.scene.duration(this.getDuration());
        this.scene.refresh();
    }

    animate() {
        const current = this.chars.length * this.progress;

        for (let index = 0; index < this.chars.length; index++) {
            if (current > index) {
                this.chars[index].classList.add('_is-active');
            } else {
                this.chars[index].classList.remove('_is-active');
            }
        }
    }

    wrapChars() {
        const text = this.container.innerText;
        const chars = text.split('');
        this.container.innerHTML = '<span>' + chars.join('</span><span>') + '</span>';
        this.chars = this.container.querySelectorAll('span');
    }
}

document.querySelectorAll('.js-karaoke').forEach(el => {
    new Karaoke(el);
});
